import I18n from '@/rI18n';

export const JOB_LIST = [
    { id: 1, value: I18n.get('LABEL-MANAGER-OFFICER') },
    { id: 2, value: I18n.get('LABEL-GENERAL- MANAGER') },
    { id: 3, value: I18n.get('LABEL-MANAGER') },
    { id: 4, value: I18n.get('LABEL-SECTION-CHIEF-MANAGER') },
    { id: 5, value: I18n.get('LABEL-GENERAL-CHIEF-CHIEF') },
    { id: 6, value: I18n.get('LABEL-GENERAL-EMPLOYEE') },
];

export const INDUSTRY = [
    { id: 1, value: I18n.get('LABEL-INFORMATION-SERVICE') },
    { id: 2, value: I18n.get('LABEL-COMMUNICATION-MEDIA') },
    { id: 3, value: I18n.get('LABEL-CHEMICAL-PETROLEUM-COAL-PRODUCTS') },
    { id: 4, value: I18n.get('LABEL-FOOD-PRODUCTS') },
    { id: 5, value: I18n.get('LABEL-ELECTRICITY-MECHANICAL') },
    { id: 6, value: I18n.get('LABEL-STEEL-METAL') },
    { id: 7, value: I18n.get('LABEL-TRANSPORTATION-EQUIMENT') },
    { id: 8, value: I18n.get('LABEL-PHARMACEUTICAL') },
    { id: 9, value: I18n.get('LABEL-OTHER-MANUFACTURING') },
    { id: 10, value:I18n.get('LABEL-SERVICE') },
    { id: 11, value:I18n.get('LABEL-CONSULTING') },
    { id: 12, value:I18n.get('LABEL-CONSTRUCTION') },
    { id: 13, value:I18n.get('LABEL-FINANCE') },
    { id: 14, value:I18n.get('LABEL-INSURANCE') },
    { id: 15, value:I18n.get('LABEL-RETAIL-WHOLESALE') },
    { id: 16, value:I18n.get('LABEL-REAL-ESTATE') },
    { id: 17, value:I18n.get('LABEL-WAREHOUSING-TRANSPORTATION-RELATED') },
    { id: 18, value:I18n.get('LABEL-ELECTRICITY-GAS') },
    { id: 19, value:I18n.get('LABEL-MEDICAL-INSTITUTION') },
    { id: 20, value:I18n.get('LABEL-GOVERMENT-OFFICE') },
    { id: 21, value:I18n.get('LABEL-LOCAL-GOVERNMENT') },
    { id: 22, value:I18n.get('LABEL-EDUCATION') },
    { id: 23, value:I18n.get('LABEL-OTHERS') },
];

export const DEFAULT_GENERAL_USER = "5";

export const STATUS_CONTRACT = {
    TRIAL: {
        LABEL_TRIAL: I18n.get('CM-CONTRACT-STATUS-TRIAL'),
        STATUS: 'trial'
    },
    ACTIVE: {
        LABEL_TRIAL: I18n.get('CM-CONTRACT-STATUS-ACTIVE'),
        STATUS: 'active'
    },
    CANCELLED: {
        LABEL_TRIAL: I18n.get('CM-CONTRACT-STATUS-CANCELLED'),
        STATUS: 'cancelled'
    },
    EXPIRED: {
        LABEL_TRIAL: I18n.get('CM-CONTRACT-STATUS-EXPIRED'),
        STATUS: 'expired'
    },
}